import {Role} from "./enums/role.enum";

export class UserGroupRoleDto {
    id: number;
    libraryGroupId: number;
    role: Role;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/user-group-role.dto.ts